<script lang="ts">
    import type {DocumentDetailReactivePageData, DocumentDetailStaticPageData} from '../types';
    import KpFavouritesPanel from '../../../favourites/kp-favourites-panel/KpFavouritesPanel.svelte';
    import {getPageContext} from 'shared/layouts/page-context';

    const pageContext = getPageContext<DocumentDetailStaticPageData, DocumentDetailReactivePageData>();
    const model = pageContext.staticData.model;
</script>

<div class="side-column-panel">
    <KpFavouritesPanel record={model.record}/>
</div>